var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper"},[_c('ImageSpinner',{staticClass:"image__spinner"}),_c('img',{staticClass:"image__item",attrs:{"data-url":_vm.srcImage,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }